import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setPopupStateChanged, setPopupStateDiff } from '#action/project/devices-popup';
import { getSymmetricDifference } from '#component/device/devices-popup/helper';

export const useDevicePopupChanges = (formDataObj, openedFromForm) => {
  const { formDevices } = useSelector(s => s.projectDevicesPopup, shallowEqual);
  const dispatch = useDispatch();
  const formValues = formDataObj?.initialFormDevices;

  useEffect(() => {
    if (!openedFromForm || !formDevices?.length || !formValues?.length) {
      return;
    }
    const symmetricDiff = getSymmetricDifference(formDevices, formValues) ?? [];
    const isChanged = Boolean(symmetricDiff.length);

    dispatch(setPopupStateChanged(isChanged));
    dispatch(setPopupStateDiff(symmetricDiff));
  }, [dispatch, formDevices, formValues, openedFromForm]);
};
